import { useState, useEffect } from "react";

const useFetch = (apiCall, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const fetchData = async () => {
      try {
        setLoading(true);
          setError(null); // Reset error state before new fetch
        setData(null); // Prevent old data from showing while loading
        const result = await apiCall({ signal: controller.signal });
        setData(result);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => controller.abort(); // Cancel request on unmount
  }, dependencies);

  return { data, loading, error };
};

export default useFetch;
